/**
 * Page dédiée Rapprochement (/admin/rapprochement/wave)
 * -----------------------------------------------------
 * Hub de rapprochement multi-sources : Wave aujourd'hui, Banque / autres demain.
 * Le sélecteur de type prépare l'architecture pour les futurs rapprochements.
 */
import React from 'react';
import { Wallet, Landmark } from 'lucide-react';
import WaveReconciliationTab from '../../components/wave/WaveReconciliationTab';
import { RequirePermission } from '../../components/permissions/RequirePermission';
import { PERMS } from '../../utils/permissions';

const RECON_TYPES = [
  { key: 'wave', label: 'Wave', icon: Wallet, available: true },
  { key: 'bank', label: 'Banque', icon: Landmark, available: false },
];

export default function ReconciliationWavePage() {
  return (
    <RequirePermission permission={PERMS.WAVE_VIEW}>
      <div className="p-4 space-y-4" data-testid="reconciliation-wave-page">
        {/* Sélecteur de type de rapprochement */}
        <div className="flex items-center gap-2" data-testid="reconciliation-type-switcher">
          {RECON_TYPES.map(({ key, label, icon: Icon, available }) => (
            <button
              key={key}
              disabled={!available}
              data-testid={`reconciliation-type-${key}`}
              title={available ? label : `${label} — bientôt disponible`}
              className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[12.5px] font-semibold border transition-colors ${
                available
                  ? 'bg-emerald-600 text-white border-emerald-600'
                  : 'bg-white text-zinc-400 border-zinc-200 cursor-not-allowed'
              }`}
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
              {!available && <span className="text-[10px] font-medium opacity-70">· bientôt</span>}
            </button>
          ))}
        </div>

        <WaveReconciliationTab />
      </div>
    </RequirePermission>
  );
}
